import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=5fad9956&scoped=true&"
import script from "./ProjectDescription.vue?vue&type=script&lang=js&"
export * from "./ProjectDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=5fad9956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad9956",
  null
  
)

export default component.exports